import SearchJob from '../views/SearchJob.vue'

export const routes = [
    {
      path: '/search-job',
      name: 'SearchJob',
      component: SearchJob,
      meta: { isPublic: true }
    }
  ]